import React from "react";
import { Modal, Button, Table } from "react-bootstrap";
import FalconCloseButton from "components/common/FalconCloseButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

const Detail = ({
    show,
    handleClose,
    data
}) => {
    const vcimage = data.vcimage === '' ? '' : `data:image/jpeg/jpg/png;base64,${data.vcimage}`
    return (
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} size="lg">
            <Modal.Header className="bg-card-gradient light border-bottom-0">
                <Modal.Title className="text-white">Detail Data</Modal.Title>
            <FalconCloseButton onClick={handleClose} variant="white" />
            </Modal.Header>
                <Modal.Body>
                    <Table bordered>
                        <tbody>
                            <tr>
                                <td width="20%">Nama</td>
                                <td>{data.vcnama}</td>
                            </tr>
                            <tr>
                                <td>Deskripsi</td>
                                <td>{data.vcdeskripsi}</td>
                            </tr>
                            <tr>
                                <td>Gambar</td>
                                <td>
                                    <img src={vcimage} alt="default" width="30%" className={vcimage === '' ? 'd-none' : ''}/>
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    <FontAwesomeIcon icon={faTimes} className="me-2" /> Tutup
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

Detail.propTypes = {}

export default Detail;